module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication",
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Judge: What is your profession?"), _c('br'), _vm._v("Brodsky: Poet. Poet and translator."), _c('br'), _vm._v("Judge: Who said you were a poet? Who assigned you that rank? "), _c('br'), _vm._v("Brodsky: No one. Who assigned me to the human race?"), _c('br')]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—")]), _vm._v("from the trial of the poet"), _c('span', {
    staticClass: "smallcaps"
  }, [_c('br')]), _vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSEPH ")]), _vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RODSKY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6fc1690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Iregreteverything_00000.vue
// module id = 69
// module chunks = 0